(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.diyCatalogReady === 'true') return;
    var weaponButtons = Array.from(root.querySelectorAll('[data-diy-weapon]'));
    var categoryNavs = Array.from(root.querySelectorAll('[data-diy-category-nav]'));
    var categoryButtons = Array.from(root.querySelectorAll('[data-diy-category-button]'));
    var panels = Array.from(root.querySelectorAll('[data-diy-category]'));
    var productChoices = Array.from(root.querySelectorAll('[data-diy-product-choice]'));
    var productSelect = root.querySelector('[data-product-select]');
    var currentProduct = root.querySelector('[data-diy-current-product]');
    var search = root.querySelector('[data-diy-search]');
    var empty = root.querySelector('[data-diy-catalog-empty]');
    var categoryTitle = root.querySelector('[data-diy-active-category]');
    var productCount = root.querySelector('[data-diy-product-count]');
    var state = { weapon: 'sword', category: '', query: '', productId: productSelect ? productSelect.value : '' };
    var copy = {
      loaded: root.dataset.labelLoaded || '已载入',
      selectProduct: root.dataset.labelSelectProduct || '选择单品',
      selectHeading: root.dataset.labelSelectHeading || '选择具体单品',
      categoryEmpty: root.dataset.labelCategoryEmpty || '当前分类暂无可定制单品'
    };

    function categoriesForWeapon() {
      return categoryButtons.filter(function (button) { return button.dataset.diyCategoryButton.indexOf(state.weapon + ':') === 0; });
    }

    function ensureCategory() {
      var available = categoriesForWeapon();
      if (!available.some(function (button) { return button.dataset.diyCategoryButton === state.category; })) {
        state.category = available[0] ? available[0].dataset.diyCategoryButton : '';
      }
    }

    function activePanel() {
      return panels.find(function (panel) { return panel.dataset.diyCategory === state.category; }) || null;
    }

    function visibleChoices() {
      var panel = activePanel();
      if (!panel) return [];
      return productChoices.filter(function (choice) {
        return panel.contains(choice) && (!state.query || choice.dataset.productName.indexOf(state.query) !== -1);
      });
    }

    function activateProduct(productId) {
      var choice = productChoices.find(function (button) {
        return button.dataset.diyProductChoice === productId && !button.hidden && activePanel() && activePanel().contains(button);
      });
      if (!choice) return;
      state.productId = productId;
      productChoices.forEach(function (button) {
        var selected = button.dataset.diyProductChoice === productId;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        var marker = button.querySelector('i');
        if (marker) marker.textContent = selected ? '✓' : '○';
        var action = button.querySelector('[data-diy-product-action]');
        if (action) action.textContent = selected ? copy.loaded : copy.selectProduct;
      });
      var title = choice.querySelector('strong');
      if (currentProduct) currentProduct.textContent = title ? title.textContent : productId;
      if (productSelect && productSelect.value !== productId) {
        productSelect.value = productId;
        productSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function render() {
      ensureCategory();
      weaponButtons.forEach(function (button) {
        var active = button.dataset.diyWeapon === state.weapon;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      categoryNavs.forEach(function (nav) { nav.hidden = nav.dataset.diyCategoryNav !== state.weapon; });
      categoryButtons.forEach(function (button) {
        var active = button.dataset.diyCategoryButton === state.category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.diyCategory !== state.category; });
      productChoices.forEach(function (choice) {
        var panel = choice.closest('[data-diy-category]');
        var match = panel && panel.dataset.diyCategory === state.category && (!state.query || choice.dataset.productName.indexOf(state.query) !== -1);
        choice.hidden = !match;
      });

      var available = visibleChoices();
      var selectedCategory = categoryButtons.find(function (button) { return button.dataset.diyCategoryButton === state.category; });
      if (categoryTitle) categoryTitle.textContent = selectedCategory ? selectedCategory.textContent.trim() : copy.selectHeading;
      if (productCount) productCount.textContent = String(available.length);
      if (empty) empty.hidden = available.length > 0;
      if (!available.some(function (choice) { return choice.dataset.diyProductChoice === state.productId; })) {
        state.productId = available[0] ? available[0].dataset.diyProductChoice : '';
      }
      if (state.productId) activateProduct(state.productId);
      else if (currentProduct) currentProduct.textContent = copy.categoryEmpty;
    }

    weaponButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.weapon = button.dataset.diyWeapon;
        state.category = '';
        state.productId = '';
        render();
      });
    });
    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.category = button.dataset.diyCategoryButton;
        state.productId = '';
        render();
      });
    });
    productChoices.forEach(function (button) {
      button.addEventListener('click', function () { activateProduct(button.dataset.diyProductChoice); });
    });
    if (search) search.addEventListener('input', function () {
      state.query = search.value.trim().toLowerCase();
      render();
    });

    root.dataset.diyCatalogReady = 'true';
    render();
  }

  function initAll(scope) {
    Array.from((scope || document).querySelectorAll('[data-diy-catalog]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
